const BROWSER_REGEX = /(opera|chrome|safari|firefox|msie|trident(?=\/))/i;

export function isChromeBrowser(): boolean {
  const match = navigator.userAgent.match(BROWSER_REGEX);

  return match !== null && match[1] === "Chrome";
}

export function isSafariBrowser(): boolean {
  const match = navigator.userAgent.match(BROWSER_REGEX);

  return (
    match !== null && match[1].toLowerCase() === "safari" && !isChromeBrowser()
  );
}
